export default {
  // LAYOUT
  appHeight: (state) => {
    return (
      state.layouts.innerHeight -
      state.layouts.appBodyPosition -
      state.layouts.appHeaderHeight -
      state.layouts.footerHeight -
      state.layouts.padding
    );
  },
  showAppDetail: (state) => {
    return state.showDetail;
  },

  // Navigation
  fetchNavigations: (state) => {
    return state.navigations.list;
  },
  fetchNavigationActive: (state) => {
    return state.navigations.active;
  },
  fetchNavigationAction: (state) => {
    return state.navigations.action;
  },
  fetchNavigationsDropdown: (state) => {
    return state.navigations.list.filter(
      (navigation) => navigation.showMobile != true
    );
  },
  // FILTER
  fetchFilterOptions: (state) => {
    return state.filter.forms;
  },
  fetchFilterSelected: (state) => (payload) => {
    return state.filter.forms.find((data) => data.value === payload.value);
  },
};
